module.exports = __webpack_public_path__ + "static/media/4z4_website_logo_sup_thku.01f4e7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z4_website_logo_sup_thku.jpg
// module id = 82
// module chunks = 0